(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5372],{

/***/ 34327:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/[shopName]",
      function () {
        return __webpack_require__(18591);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 64725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var FullWidthContainer = function(param) {
    var children = param.children;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "relative w-screen right-[50%] left-[50%] -mx-[50vw]",
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FullWidthContainer);


/***/ }),

/***/ 97995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var FullWidthSection = function(param) {
    var children = param.children, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? "transparent" : _backgroundColor, _padding = param.padding, padding = _padding === void 0 ? "py-6" : _padding, _classProvided = param.classProvided, classProvided = _classProvided === void 0 ? "" : _classProvided, bgImmage = param.bgImmage;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "relative w-screen ".concat(backgroundColor, " ") + classProvided,
        style: {
            left: "50%",
            right: "50%",
            marginLeft: "-50vw",
            marginRight: "-50vw",
            backgroundImage: bgImmage !== undefined ? "url(".concat(bgImmage, ")") : "",
            backgroundRepeat: bgImmage !== undefined ? "no-repeat" : "",
            backgroundPosition: bgImmage !== undefined ? "right 3% bottom 7%" : "",
            backgroundSize: bgImmage !== undefined ? "160px 160px" : ""
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "container ".concat(padding),
            children: children
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FullWidthSection);


/***/ }),

/***/ 7708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11752);


var ref = (0,next_config__WEBPACK_IMPORTED_MODULE_1__["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, websiteName = _publicRuntimeConfig.settings.websiteName;
var ArrowRight = function(param) {
    var _width = param.width, width = _width === void 0 ? "8" : _width, _height = param.height, height = _height === void 0 ? "13" : _height;
    return websiteName === "bricostore" ? // Material Design "chevron_right" (Apache-2.0). viewBox cropped to the glyph bounding box
    // so it fills the width/height box like the original icon. Color via currentColor.
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "8.59 6 7.41 12",
        fill: "currentColor",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6Z"
        })
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "#000",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M1.4 0 .7.7l5.6 5.7L.6 12l.7.7L7 7.1l.7-.7-.7-.7L1.4 0Z"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ArrowRight);


/***/ }),

/***/ 6250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11752);



var ref = (0,next_config__WEBPACK_IMPORTED_MODULE_2__["default"])(), settings = ref.publicRuntimeConfig.settings;
var ResponsiveShopBanner = function(param) {
    var banner = param.banner;
    var ref3, ref1, ref2;
    var desktopImage = (ref3 = banner.images) === null || ref3 === void 0 ? void 0 : ref3.desktop;
    var tabletImage = (ref1 = banner.images) === null || ref1 === void 0 ? void 0 : ref1.tablet;
    var mobileImage = (ref2 = banner.images) === null || ref2 === void 0 ? void 0 : ref2.mobile;
    var link = banner.url;
    var hasImage = desktopImage || tabletImage || mobileImage;
    if (!hasImage) {
        return null;
    }
    if (link) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
            href: link,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                title: "",
                children: [
                    mobileImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "".concat(settings.cdn).concat(mobileImage),
                        className: "w-full sm:hidden",
                        alt: ""
                    }),
                    tabletImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "".concat(settings.cdn).concat(tabletImage),
                        className: "w-full hidden sm:block lg:hidden",
                        alt: ""
                    }),
                    desktopImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "".concat(settings.cdn).concat(desktopImage),
                        className: "w-full hidden lg:block",
                        alt: ""
                    })
                ]
            })
        }));
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            mobileImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "".concat(settings.cdn).concat(mobileImage),
                className: "w-full sm:hidden",
                alt: ""
            }),
            tabletImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "".concat(settings.cdn).concat(tabletImage),
                className: "w-full hidden sm:block lg:hidden",
                alt: ""
            }),
            desktopImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "".concat(settings.cdn).concat(desktopImage),
                className: "w-full hidden lg:block",
                alt: ""
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ResponsiveShopBanner);


/***/ }),

/***/ 18591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _shopName_; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./lib/api/helpers.js
var helpers = __webpack_require__(45963);
// EXTERNAL MODULE: ./lib/api/index.js
var api = __webpack_require__(2642);
// EXTERNAL MODULE: ./components/ShopInShop/ResponsiveShopBanner.js
var ResponsiveShopBanner = __webpack_require__(6250);
// EXTERNAL MODULE: ./components/FullWidthSection.js
var FullWidthSection = __webpack_require__(97995);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
;// CONCATENATED MODULE: ./components/ShopInShop/Navbar.js


var ShopInShopNavbar = function(param) {
    var menu = param.menu;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("menu", {
        className: "flex text-[12px] gap-[30px] container",
        children: menu.map(function(menuItem, index) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                className: "text-white min-w-fit hover:text-[#FFCB05] border-b border-transparent hover:border-[#FFCB05]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                    href: menuItem.url,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        title: menuItem.name,
                        className: "block",
                        children: menuItem.name
                    })
                })
            }, index);
        })
    });
};
/* harmony default export */ var Navbar = (ShopInShopNavbar);

// EXTERNAL MODULE: ./containers/ErrorPage.js
var ErrorPage = __webpack_require__(75720);
// EXTERNAL MODULE: ./components/Heading.js
var Heading = __webpack_require__(73510);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./lib/helpers.js
var lib_helpers = __webpack_require__(15722);
;// CONCATENATED MODULE: ./components/ShopInShop/CategoryCard.js





var ref = (0,config["default"])(), settings = ref.publicRuntimeConfig.settings;
var CategoryCard = function(param) {
    var category = param.category;
    var linkTarget = category.use_anchors ? "#".concat((0,lib_helpers/* getSlug */.QF)("gama-produse-".concat(category.slug))) : category.url;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                href: linkTarget,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    title: category.name,
                    className: "py-[30px] px-[20px]",
                    children: category.image && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "".concat(settings.cdn).concat(category.image),
                        alt: category.seo.title || category.name
                    })
                })
            }),
            category.name && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                as: "h2",
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                    href: linkTarget,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        title: category.name,
                        children: category.name
                    })
                }),
                classesProp: "text-[20px] md:text-[22px] leading-[20px] md:leading-[28px] -tracking-[0.28px] text-center"
            })
        ]
    }));
};
/* harmony default export */ var ShopInShop_CategoryCard = (CategoryCard);

;// CONCATENATED MODULE: ./components/ShopInShop/CategoriesList.js


var CategoriesList = function(param) {
    var categories = param.categories;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("ul", {
        className: "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-[10px] md:gap-[20px]",
        children: categories.map(function(category) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                className: "flex flex-col border-gray-1100 bg-white border rounded-[6px] py-[30px] px-[20px] h-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopInShop_CategoryCard, {
                    category: category
                })
            }, category.slug);
        })
    });
};
/* harmony default export */ var ShopInShop_CategoriesList = (CategoriesList);

// EXTERNAL MODULE: ./components/Icons/ArrowRight.js
var ArrowRight = __webpack_require__(7708);
;// CONCATENATED MODULE: ./components/ShopInShop/Category.js







var Category = function(param) {
    var category = param.category;
    var hasTopBanner = category.banners.find(function(banner) {
        return banner.position === "top";
    });
    var hasBottomBanner = category.banners.find(function(banner) {
        return banner.position === "bottom";
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: (0,lib_helpers/* getSlug */.QF)("gama-produse-".concat(category.slug)),
        children: [
            hasTopBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-[60px] rounded-tr-[10px] rounded-bl-[10px] md:rounded-tr-[20px] md:rounded-bl-[20px] overflow-hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveShopBanner/* default */.Z, {
                    banner: hasTopBanner
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between items-center mb-[20px]",
                children: [
                    category.name && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        title: category.name,
                        as: "h2",
                        classesProp: "text-[24px] md:-text-[32px] -tracking-[0.66px] leading-normal"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden md:block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                            href: category.url,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: "flex items-center gap-[4px] text-[14px] font-medium -tracking-[0.19px]",
                                title: "",
                                children: [
                                    "Vezi intreaga gama de produse ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRight/* default */.Z, {})
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopInShop_CategoriesList, {
                categories: category.children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "md:hidden flex justify-center mt-[30px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                    href: category.url,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        className: "flex items-center gap-[4px] text-[14px] font-medium -tracking-[0.19px]",
                        title: "",
                        children: [
                            "Vezi intreaga gama de produse ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRight/* default */.Z, {})
                        ]
                    })
                })
            }),
            hasBottomBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-[60px] rounded-tr-[10px] rounded-bl-[10px] md:rounded-tr-[20px] md:rounded-bl-[20px] overflow-hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveShopBanner/* default */.Z, {
                    banner: hasBottomBanner
                })
            })
        ]
    }));
};
/* harmony default export */ var ShopInShop_Category = (Category);

// EXTERNAL MODULE: ./components/FullWidthContainer.js
var FullWidthContainer = __webpack_require__(64725);
;// CONCATENATED MODULE: ./pages/shop/[shopName]/index.js













function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var ShopInShopPage = function(param) {
    var categories = param.categories, banners = param.banners, menu = param.menu, seo = param.seo, categoriesWithChildren = param.categoriesWithChildren;
    if (!categories) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* default */.Z, {
            layout: "404"
        }));
    }
    var hasTopBanner = banners && banners.find(function(banner) {
        return banner.position === "top";
    });
    var hasBottomBanner = banners && banners.find(function(banner) {
        return banner.position === "bottom";
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(head["default"], {
                children: [
                    seo.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        /*#__PURE__*/ children: seo.title
                    }),
                    seo.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: seo.description
                    })
                ]
            }),
            menu && /*#__PURE__*/ (0,jsx_runtime.jsx)(FullWidthContainer/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                    className: "bg-black leading-[50px] overflow-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar, {
                        menu: menu
                    })
                })
            }),
            hasTopBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-[25px] md:mt-[60] md:rounded-tr-[20px] md:rounded-bl-[20px] overflow-hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FullWidthSection/* default */.Z, {
                    padding: "p-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveShopBanner/* default */.Z, {
                        banner: hasTopBanner
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-[25px] md:mt-[70px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        title: "Categorii de produse",
                        as: "h2",
                        classesProp: "text-[24px] -tracking-[0.66px] leading-normal"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-[16px] md:mt-[20px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopInShop_CategoriesList, {
                            categories: categories
                        })
                    }),
                    categoriesWithChildren && categoriesWithChildren.map(function(category) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                            className: "mt-[25px] md:mt-[70px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopInShop_Category, {
                                category: category
                            })
                        }, category.slug);
                    })
                ]
            }),
            hasBottomBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-[25px] md:mt-[60] md:rounded-tr-[20px] md:rounded-bl-[20px] overflow-hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FullWidthSection/* default */.Z, {
                    padding: "p-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveShopBanner/* default */.Z, {
                        banner: hasBottomBanner
                    })
                })
            }),
            (seo === null || seo === void 0 ? void 0 : seo.footer_description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-[20px]",
                dangerouslySetInnerHTML: {
                    __html: seo.footer_description
                }
            })
        ]
    }));
};
ShopInShopPage.getInitialProps = (function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(ctx) {
        var query, response1, ref2, ref1, updatedReponse, categoriesWithChildren;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    query = ctx.query;
                    _ctx.next = 3;
                    return (0,helpers/* makeApiCall */.Vo)({
                        apiArgs: [
                            {
                                shopName: query.shopName
                            }
                        ],
                        apiCall: api/* getShopInShopCategoriesApi */.ij6,
                        returnResponse: true,
                        formatResponse: function(response) {
                            return response.data;
                        }
                    });
                case 3:
                    response1 = _ctx.sent;
                    if (!(response1 && response1.status)) {
                        _ctx.next = 10;
                        break;
                    }
                    ;
                    updatedReponse = _objectSpread({}, response1);
                    if (((ref2 = response1.menu) === null || ref2 === void 0 ? void 0 : ref2.length) === 0) {
                        updatedReponse.menu = null;
                    }
                    if (((ref1 = response1.categories) === null || ref1 === void 0 ? void 0 : ref1.length) > 0) {
                        categoriesWithChildren = response1.categories.filter(function(category) {
                            var ref;
                            return ((ref = category.children) === null || ref === void 0 ? void 0 : ref.length) > 0;
                        });
                        if (categoriesWithChildren.length !== 0) {
                            updatedReponse.categoriesWithChildren = categoriesWithChildren;
                        }
                    }
                    return _ctx.abrupt("return", _objectSpread({}, updatedReponse, {
                        query: query
                    }));
                case 10:
                    return _ctx.abrupt("return", {
                        query: query
                    });
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(ctx) {
        return _ref.apply(this, arguments);
    };
})();
ShopInShopPage.pageLayout = "default";
/* harmony default export */ var _shopName_ = (ShopInShopPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(34327); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);